import { Container } from "./Container";
import heroImg from "../assets/img/hero.png";

// Translation
import { useTranslation } from "react-i18next";

import { dataFR } from "../assets/data/fr";
import { dataEN } from "../assets/data/en";
import { dataNL } from "../assets/data/nl";

export const Hero = () => {
  const { i18n } = useTranslation();

  let data = dataFR;
  if (i18n.language === "fr") {
    data = dataFR;
  } else if (i18n.language === "en") {
    data = dataEN;
  } else if (i18n.language === "nl") {
    data = dataNL;
  }

  return (
    <>
      <Container className="flex flex-wrap p-8">
        <div className="flex items-center w-full lg:w-1/2">
          <div className="max-w-2xl mb-8">
            <div className="mb-4 inline-flex rounded-full bg-[#43A047]/8 px-4 py-2 text-xs font-semibold uppercase tracking-[0.24em] text-[#43A047]">
              {data.hero.eyebrow}
            </div>
            <h1 className="text-4xl font-bold leading-snug tracking-tight text-green-600 lg:text-4xl lg:leading-tight xl:text-6xl xl:leading-tight ">
              {data.hero.title}
            </h1>
            <p className="py-5 text-xl leading-normal text-gray-500 lg:text-xl xl:text-2xl dark:text-gray-300">
              {data.hero.desc}
            </p>
          </div>
        </div>
        <div className="flex items-center justify-center w-full lg:w-1/2">
          <div className="relative w-full max-w-[44rem] rounded-[36px] bg-gradient-to-br from-[#f7fbf7] via-white to-[#edf7ee] p-4 lg:rounded-[48px] lg:p-5">
            <div className="absolute -left-6 top-10 hidden rounded-[28px] bg-white px-5 py-4 shadow-[0_20px_45px_rgba(15,23,42,0.08)] lg:block">
              <div className="text-[0.7rem] font-semibold uppercase tracking-[0.24em] text-[#43A047]/70">
                {data.hero.sinceLabel}
              </div>
              <div className="mt-1 text-3xl font-bold text-slate-800">1988</div>
            </div>

            <img
              src={heroImg}
              width="616"
              height="617"
              className="w-full object-cover rounded-[30px] lg:rounded-[42px]"
              alt="Pharma Manufacturing Building"
              loading="eager"
              placeholder="blur"
            />

            <div className="absolute -bottom-5 right-8 hidden max-w-[14rem] rounded-[28px] bg-[#43A047] px-5 py-4 text-white shadow-[0_20px_45px_rgba(67,160,71,0.24)] lg:block">
              <div className="text-[0.7rem] font-semibold uppercase tracking-[0.24em] text-white/75">
                {data.hero.calloutLabel}
              </div>
              <div className="mt-2 text-lg font-semibold leading-tight">
                {data.hero.calloutText}
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Container>
        <div className="flex flex-col justify-center">
          <div className="text-xl text-center text-gray-700 dark:text-white">
            {data.hero.subDesc}
          </div>
        </div>
      </Container>
    </>
  );
};
